<template>
    <div class="w-full bg-main shadow-lowerHeader sticky top-0 min-h-[40px] z-10">
      <div class="container mx-auto max-w-custom min-h-[30px] flex" v-if="user">
        <div 
        v-for="item in headers"
        :key="item.route"
        class="flex items-center justify-center">
          <LinkComponent :text="item.title" :link="item.route" :inner="item.children" type="lower"/>
        </div>
      </div>
    </div>
</template>

<script>
import LinkComponent from '@/Header/Desktop/LinkComponent.vue'

export default {
  name: 'LowerHeader',
  props: {
    headers: {
      type: Object,
      required: true
    }
  },
  components: {
    LinkComponent
  },
  data(){
    return {
      user: null
    }
  },
  mounted(){
    this.user = this.$userStore.user
  },
  watch: {
    $route(){
      this.user = this.$userStore.user
    }
  }
}
</script>